module.exports = __webpack_public_path__ + "media/images/bubble-img-04-36188c08bb9100c588615bd8600cdccb.svg";